import './commonroots/style';
import FormStructure from './commonroots/form_structure';

export default FormStructure;